import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import CreatableSelect from 'react-select/lib/Creatable'
import Slider from '_components/slider'
import FormElement from '_components/formElement'
import FormBody from '_components/formBody'


const createOption = (label: string) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ''),
})

const defaultOptions = [
  createOption('Joy'),
  createOption('Sadness'),
  createOption('Anger'),
  createOption('Fear'),
  createOption('Surprise'),
  createOption('Love'),
]

import styles from './styles.css'
import Answer from './answer'

import Icon from '_components/icon'
import CategoryTabBodySwipe from '../categoryTabBodySwipe'

import { updateLastActivityAt } from '_modules/user/actions'
import { createNonTask, getNonTasks } from '_modules/non-task/actions'

const mapStateToProps = ({}) => ({})

const mapDispatchToProps = {
  updateLastActivityAt,
  createNonTask,
  getNonTasks,
}

class EmotionsForm extends PureComponent {
  static propTypes = {
    closePlusForm: PropTypes.func.isRequired,
    createNonTask: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    getNonTasks: PropTypes.func.isRequired,
  }

  state = {
    isLoading: false,
    options: defaultOptions,
    emotionName: undefined,
    reflection: '',
    rank: 5,
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown = event => {
    if (event.key === 'Enter') {
      this.onSave()
    }
  }

  handleChange = (newValue: any, actionMeta: any) => {
    this.setState({ emotionName: newValue })
  }

  handleCreate = (inputValue: any) => {
    this.setState({ isLoading: true })
    // console.group('Option created')
    // console.log('Wait a moment...')
    setTimeout(() => {
      const { options } = this.state
      const newOption = createOption(inputValue)
      // console.log(newOption)
      // console.groupEnd()
      this.setState({
        isLoading: false,
        options: [...options, newOption],
        emotionName: newOption,
      })
    }, 1000)
  }

  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onSave = () => {
    const { emotionName, rank, reflection } = this.state

    if (!emotionName || !rank || !reflection) {
      this.props.displayError('Missing Fields')
      return
    }

    const payload = {
      type: 1,
      label: emotionName.label,
      rank,
      reflection,
    }

    this.props.createNonTask(payload)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
    this.resetPlusForm()
    this.props.closePlusForm()
  }

  onCancel = () => {
    this.props.closePlusForm()
  }

  resetPlusForm = () => {
    this.props.getNonTasks()
    this.setState({
      isLoading: false,
      options: defaultOptions,
      emotionName: undefined,
      reflection: '',
      rank: 0,
    })
  }

  render() {
    const { isLoading, options, emotionName, rank, reflection } = this.state

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: 'auto',
        border: ' 1px solid rgba(255,255,255,0.3)',
      }),
      placeholder: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      singleValue: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      input: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      menu: (provided, state) => ({
        ...provided,
        backgroundColor: 'rgba(80,95,172,0.8)',
        fontSize: 16,
        color: 'white',
      }),
      option: (provided, { isFocused }) => {
        return {
          ...provided,
          color: isFocused ? 'black' : 'white',
        }
      },
    }

    const buttons = [
      { label: 'Save', onClick: this.onSave },
      { label: 'Cancel', onClick: this.onCancel },
    ]

    return (
      <CategoryTabBodySwipe question="Learn more here!" answer={<Answer />}>
        <FormBody buttons={buttons}>
          <FormElement label="Emotion">
            <CreatableSelect
              isClearable
              isDisabled={isLoading}
              isLoading={isLoading}
              onChange={this.handleChange}
              onCreateOption={this.handleCreate}
              options={options}
              value={emotionName}
              styles={customStyles}
            />
          </FormElement>
          <FormElement label="Rank">
            <Slider
              min={1}
              max={10}
              value={rank}
              onChange={rank => this.setState({ rank })}
              color="#F46063"
            />
          </FormElement>
          <FormElement label="Reflection" labelStyle={{ alignSelf: 'flex-start' }}>
            <textarea
              id="reflection"
              rows="6"
              value={reflection}
              className={classnames(styles['form-textarea'])}
              onChange={this.onChange}
            />
          </FormElement>
        </FormBody>
      </CategoryTabBodySwipe>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmotionsForm)



// WEBPACK FOOTER //
// ./src/components/categoryTabs/emotionsForm/index.js